import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import { push } from 'connected-react-router';

import apiAuthCall from 'helpers/apiAuthCall';
import { throttle } from 'helpers/sagaEffects';
import {
    fetchListSuccess,
    actions,
    createDynamicProfileForm,
    updateDynamicProfileForm,
    fetchDynamicProfileSuccess,
} from './duck';
import {
    dynamicProfilesEndpoint,
    dynamicProfileSingleEndpoint,
} from './selectors';

export function* createDynamicProfile(api, action) {
    const notificationId = 'createDynamicProfile';

    try {
        const payload = action.payload;

        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(dynamicProfilesEndpoint),
                data: payload
            }
        );

        yield put(createDynamicProfileForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Dynamic Profile'} created!`,
            status: result.status
        }));
        yield put(push(`/admin/dynamic-profiles/${result.data.id}`));
    } catch (err) {
        yield put(createDynamicProfileForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchDynamicProfilesList(api, action) {
    const notificationId = 'getDynamicProfilesList';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(dynamicProfilesEndpoint)
            }
        );

        yield put(fetchListSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchDynamicProfile(api, action) {
    const notificationId = action.type;
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(dynamicProfileSingleEndpoint, action.payload)
            }
        );

        yield put(fetchDynamicProfileSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* deleteDynamicProfile(api, confirmMsg, action) {
    const notificationId = 'deleteDynamicProfile';

    if (!confirmMsg(`Are you sure you wish to delete ${action.payload.name}?`)) { // eslint-disable-line no-alert
        return;
    }

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'delete',
                url: yield select(dynamicProfileSingleEndpoint, { dynamicProfileId: action.payload.id }),
                data: action.payload
            }
        );

        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Dynamic Profile'} deleted!`,
            status: result.status
        }));
        yield put(push('/admin/dynamic-profiles'));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* updateDynamicProfile(api, action) {
    const notificationId = 'updateDynamicProfile';
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'put',
                url: yield select(dynamicProfileSingleEndpoint, { dynamicProfileId: action.payload.id }),
                data: action.payload
            }
        );
        yield put(updateDynamicProfileForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Dynamic Profile'} updated!`,
            status: result.status
        }));
        yield put(push('/admin/dynamic-profiles'));
    } catch (err) {
        yield put(updateDynamicProfileForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}


export default function* dynamicProfileSaga({ api }) {
    yield all([
        takeLatest(createDynamicProfileForm.REQUEST, createDynamicProfile, api),
        takeLatest(updateDynamicProfileForm.REQUEST, updateDynamicProfile, api),
        throttle(200, actions.FETCH_DYNAMIC_PROFILE_LIST, fetchDynamicProfilesList, api),
        takeLatest(actions.FETCH_DYNAMIC_PROFILE, fetchDynamicProfile, api),
        takeLatest(actions.DELETE_DYNAMIC_PROFILE, deleteDynamicProfile, api, window.confirm),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/dynamicProfiles/saga.js